import dayjs, { ConfigType } from 'dayjs';

/**
 * Une date de clôture telle qu'elle se lit dans les libellés verrouillés le 11/09 :
 * « Solde au 1ᵉʳ janvier 2026 ». Le premier du mois prend l'ordinal français ; les autres jours
 * non — une clôture tombe toujours un 1er, mais le format ne le suppose pas.
 */
export const formatClosingDate = (date: ConfigType, locale: string): string => {
  const closingDay = dayjs(date).locale(locale);

  if (!locale.startsWith('fr')) return closingDay.format('MMMM D, YYYY');

  const dayLabel = closingDay.date() === 1 ? '1ᵉʳ' : String(closingDay.date());
  return `${dayLabel} ${closingDay.format('MMMM YYYY')}`;
};
